import {
  all, call, takeLatest, put, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import { initAppActionType } from '../../model/application/actions';
import { appInitAction } from '../actions/appActions';
import { Bot } from '../../model/bot/types';
import { navigate } from "@reach/router";
import { fillBotAction, changeSelectedBotAction } from '../actions/botActions';
import _ from 'lodash';

function* fetchRessources() {
  const botId = yield select(state => state.bot.selectedBot);

  const responseBots = yield call(Api.bots.get, botId);
  yield put(fillBotAction.success(responseBots.data as Bot[]))
  if(!_.isEmpty(responseBots.data)){
    yield put(changeSelectedBotAction.request(responseBots.data[0].id))
  }
  if(_.includes(window.location.toString(), 'oidcCallback') || _.includes(window.location.toString(), 'initError')){
    navigate("/");
  }
}

function* initApp(action: any) {
  try {
    yield call(fetchRessources);
    yield put(appInitAction.success({}));
  } catch (error) {
    navigate("/initError");
    yield put(appInitAction.failure());
  }
}

export default function* appSagas() {
  yield all([takeLatest(initAppActionType.request, initApp)]);
}
